import { Grid, Typography } from '@silverstein-properties/inspirelabs-ui';
import { Skeleton, Paper } from '@mui/material';
import RoundButton from '../RoundButton/Component';

const MiniCardSkeleton = () => {
  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item>
            <Skeleton variant="rounded" height={80} width={80} />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h4">
              <Skeleton />
            </Typography>
            <Typography variant="body2">
              <Skeleton />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography sx={{ mt: 0.6 }}>
              <Skeleton />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography sx={{ mt: 0.6 }}>
              <Skeleton />
            </Typography>
          </Grid>
          <Grid item xs>
            <Skeleton sx={{ float: 'right' }}>
              <RoundButton
                text="Skeleton"
                default="white-navy small"
                hover="blue small"
              />
            </Skeleton>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default MiniCardSkeleton;
